import {connect} from "react-redux";
import MrfListing from "./Listing";
import {bindActionCreators} from "redux";
import {
    getPending
} from "../../../services/redux/MaterialRequistionForm/action";

const mapStateToProps = (state) => ({
    pendingListing: state.MaterialRequistionForm.pendingListing,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getPending
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(MrfListing);
